// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bek_a bhf_bk bhf_bl bhf_bo","SwipeLeftToClose--animating":"bek_b"};